import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { routes } from '../../core.index';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private collapseSubject = new BehaviorSubject<boolean>(false);
  collapse$ = this.collapseSubject.asObservable();

  toggleCollapse() {
    this.collapseSubject.next(!this.collapseSubject.value);
  }

  public sideBarPosition: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('sideBarPosition') || 'false'
  );

  public toggleMobileSideBar: BehaviorSubject<string> =
    new BehaviorSubject<string>(
      localStorage.getItem('isMobileSidebar') || 'false'
    );

  public expandSideBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  public switchSideMenuPosition(): void {
    if (localStorage.getItem('sideBarPosition')) {
      this.sideBarPosition.next('false');
      this.expandSideBar.next(true);
      localStorage.removeItem('sideBarPosition');
    } else {
      this.sideBarPosition.next('true');
      this.expandSideBar.next(false);
      localStorage.setItem('sideBarPosition', 'true');
    }
  }

  public switchMobileSideBarPosition(): void {
    if (localStorage.getItem('isMobileSidebar')) {
      this.toggleMobileSideBar.next('false');
      localStorage.removeItem('isMobileSidebar');
    } else {
      this.toggleMobileSideBar.next('true');
      localStorage.setItem('isMobileSidebar', 'true');
    }
  }

  public adminMenu = [
    {
      tittle: 'Menu',
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Dashboard',
          icon: 'grid',
          route: routes.dashboard,
          hasSubRoute: false,
          showSubRoute: false,
        },
        {
          menuValue: 'Events',
          icon: 'plus-square',
          route: routes.events,
          hasSubRoute: false,
          showSubRoute: false,
        },
        {
          menuValue: 'Contacts',
          icon: 'users',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.contacts,
          subRoutes: [],
        },
        {
          menuValue: 'News',
          icon: 'file-text',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.news,
          subRoutes: [],
        },
        {
          menuValue: 'App Users',
          icon: 'user',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.clients,
          subRoutes: [],
        },
        {
          menuValue: 'Admin User Management',
          icon: 'users',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.admin,
          subRoutes: [],
        },
        {
          menuValue: 'Mobile Menus',
          icon: 'smartphone',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.mobileMenus,
          subRoutes: [],
        }
      ],
    },
  ];
  public managerMenu = [
    {
      tittle: 'Menu',
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Events',
          icon: 'plus-square',
          route: routes.events,
          hasSubRoute: false,
          showSubRoute: false,
        },
        {
          menuValue: 'Contacts',
          icon: 'users',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.contacts,
          subRoutes: [],
        },
        {
          menuValue: 'News',
          icon: 'file-text',
          hasSubRoute: false,
          showSubRoute: false,
          route: routes.news,
          subRoutes: [],
        },
      ],
    },
  ];
  public subscriberMenu = [
    {
      tittle: 'Menu',
      showAsTab: true,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Events',
          icon: 'plus-square',
          route: routes.events,
          hasSubRoute: false,
          showSubRoute: false,
        },
      ],
    },
  ];
}
